import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { kioskPages, kioskRoot, redesignPages, routesPartOfKioskFlow } from "src/services/navigation/paths.const";
import { isInKioskMode } from "src/services/utils/kiosk-mode.utils";

const routeIsOnKioskPath = (currentRoute: string): boolean => {
  return currentRoute.startsWith(kioskRoot);
};

const handleKioskFlowRedirection = async (currentRoute: string, router: Router): Promise<boolean> => {
  const isOnKioskPath = routeIsOnKioskPath(currentRoute);
  if (isOnKioskPath) {
    return true;
  } else if (routesPartOfKioskFlow.some((route) => currentRoute.startsWith(route))) {
    return true;
  } else {
    await router.navigate([kioskPages.landing]);
    return false;
  }
};

const handleNonKioskFlowRedirection = async (currentRoute: string, router: Router): Promise<boolean> => {
  const isOnKioskPath = routeIsOnKioskPath(currentRoute);
  if (!isOnKioskPath) {
    return true;
  } else {
    await router.navigate([redesignPages.landing]);
    return false;
  }
};

export const KioskGuard = async (route: ActivatedRouteSnapshot): Promise<boolean> => {
  const router = inject(Router);
  const currentRoute = route.url.toString();

  if (isInKioskMode()) {
    return handleKioskFlowRedirection(currentRoute, router);
  } else {
    return handleNonKioskFlowRedirection(currentRoute, router);
  }
};
